import React, { useState, useEffect } from 'react'
import { useDispatch } from "react-redux"
import { appendFilters } from 'store/adminFilter/actions'
import { Link } from 'react-router-dom'
import { providerPrefix } from 'configs/routePrefix'
 
const CardItem = ({ index, item, Service, setShouldGetData }) => {
    const status = item.status
    const [itemStatus, setItemStatus] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        setItemStatus(status)
    }, [status])

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>{item?.id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>
                    <Link to={`${providerPrefix}/Admin-developer/property`} 
                        onClick={()=> {
                            localStorage.setItem("building_id", item.id)
                            dispatch(appendFilters({building_id: item?.id}))
                        }}>
                        {item.name ?.en}
                    </Link>
                </td>
                <td className='font-size-13'>{item?.floors_num}</td>
                <td className='font-size-13'>{item?.available_units_count}</td>
                <td className='font-size-13'>{item?.bought_units_count}</td>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                readOnly={true}
                            />
                        </div>
                    </form>
                </td>
            </tr>
        </>

    )
}

export default CardItem